"use client";

import type { UserId } from "@nimble/datamodel/types/userId";
import { CACHE_REVALIDATE_5_MIN_MS } from "@nimble/react-requests/api-clients/caching-strategy";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import {
  CandidateCountsResponse,
  getCandidateCounts,
} from "@/lib/api-clients/recommendation-api-client";

const CANDIDATE_COUNTS_QUERY_KEY = "candidateCounts";

export function getCandidateCountsQueryKey(userId: UserId | undefined) {
  return [CANDIDATE_COUNTS_QUERY_KEY, userId];
}

type UseCandidateCountsOptions = Omit<
  UseQueryOptions<CandidateCountsResponse>,
  "queryKey" | "queryFn"
>;

export function useCandidateCounts(
  userId: UserId | undefined,
  options?: UseCandidateCountsOptions,
) {
  const queryOptions = options ?? {};

  return useQuery({
    queryKey: getCandidateCountsQueryKey(userId),
    queryFn: async () => {
      if (!userId) throw new Error("userId is required");
      const response = await getCandidateCounts(userId);
      return response.data;
    },
    enabled: !!userId,
    staleTime: CACHE_REVALIDATE_5_MIN_MS,
    ...queryOptions,
  });
}
